import createBaseFor from "./component-library363.mjs";
var baseFor = createBaseFor();
const baseFor$1 = baseFor;
export {
  baseFor$1 as default
};
